import React from 'react';
import { useScheduledCommandPanelModel } from '../hooks/useScheduledCommandPanelModel';
import ScheduledCommandPanelModals from './ScheduledCommandPanel/ScheduledCommandPanelModals';
import ScheduledCommandPanelToolbar from './ScheduledCommandPanel/ScheduledCommandPanelToolbar';
import { ScheduledCommandPanelProps as Props } from './ScheduledCommandPanel/types';
import ScheduledCommandPanelViews from './ScheduledCommandPanel/ScheduledCommandPanelViews';

const ScheduledCommandPanel: React.FC<Props> = (props) => {
  const model = useScheduledCommandPanelModel(props);

  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-[0_12px_35px_rgba(15,23,42,0.06)] space-y-6">
      <ScheduledCommandPanelToolbar model={model} />
      <ScheduledCommandPanelViews model={model} />
      <ScheduledCommandPanelModals model={model} />
    </section>
  );
};

export default ScheduledCommandPanel;
